<table
  mat-table
  [attr.multiTemplateDataRows]="allowMultiTemplateRows"
  [class.big-table]="isTableBig"
  [class.small-table]="isTableSmall"
  [dataSource]="dataSource"
>
  <ng-content></ng-content>

  <ng-container [matColumnDef]="ExtraColumnType.EMPTY_TABLE">
    <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay?.length">
      No data. Table empty.
    </td>
  </ng-container>

  <ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  </ng-container>

  <ng-container *ngIf="dataSource?.items.length > 0">
    <tr
      *matRowDef="let row; columns: columnsToDisplay;"
      mat-row
      [attr.matRipple]="allowMultiTemplateRows"
      [class.expanded-row]="isElementExpanded(row)"
      (click)="toggleExpandedElement(row)"
    ></tr>
  </ng-container>

  <ng-container>
    <tr
      class="footer-row"
      [class.hidden]="dataSource?.items.length > 0"
      mat-footer-row
      *matFooterRowDef="[ExtraColumnType.EMPTY_TABLE]"
    ></tr>
  </ng-container>
</table>
